import { render } from "./RentPropDetailView.vue?vue&type=template&id=b5303b90&scoped=true"
import script from "./RentPropDetailView.vue?vue&type=script&lang=js"
export * from "./RentPropDetailView.vue?vue&type=script&lang=js"

import "./RentPropDetailView.vue?vue&type=style&index=0&id=b5303b90&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5303b90"]])

export default __exports__